import React, { useRef, useState } from 'react'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { Button } from '@material-ui/core'

import {
  Container,
  ContentHeader,
  DriveTour,
  LoadingFeedback,
  Page,
} from 'components'
import { AssetInventoryForm } from './components'

import useAssetInventory from 'hooks/useAssetInventory'
import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'

const AssetInventoryEdit = ({ match }) => {
  const { assetInventoryId } = match.params
  const { MANAGE_STEP_1, MANAGE_STEP_3, MANAGE_STEPS_OBJECT } =
    constants.tours.assetInventory

  const [loading, setLoading] = useState(false)
  const [openTour, setOpenTour] = useState(false)

  const formRef = useRef()

  const { isLoading } = useAssetInventory()

  const { response, isLoading: loadingAssetInventory } = useFetch(
    service.dponet.assetInventory.get,
    { assetInventoryId },
    [assetInventoryId],
    !!assetInventoryId,
  )

  const assetInventory = response?.data?.assetInventory

  const requestIsLoading = isLoading || loadingAssetInventory

  const filteredSteps = MANAGE_STEPS_OBJECT.filter((step) => {
    if (step.element === '#' + MANAGE_STEP_3) {
      return formRef?.current?.hasSelectedCategoryFields()
    }
    return true
  })

  const handleOpenTour = () => setOpenTour((prev) => !prev)

  return (
    <Page title="Editar inventário de ativos">
      <Container maxWidth={false}>
        <LoadingFeedback open={loading || requestIsLoading} />
        <ContentHeader title="Editar inventário de ativos">
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
            id={MANAGE_STEP_1}
            fullWidth
          >
            Tutorial
          </Button>
        </ContentHeader>
        {!requestIsLoading && (
          <AssetInventoryForm
            ref={formRef}
            setLoading={setLoading}
            assetInventory={assetInventory}
            mode="edit"
          />
        )}
      </Container>
      <DriveTour
        stepsMatrix={filteredSteps}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default AssetInventoryEdit
